import { SB } from '@play-co/replicant';
import { buddiesStatus } from './buddies.ruleset';

// Schema for a friend in the friends list
const buddiesPlayerSchema = SB.object({
  // The friend contribution score
  score: SB.int(),
  // The friend status, can be 'active', 'inviteSent' or 'inviteReceived'
  status: SB.tuple(buddiesStatus),
  // Timestamp when the score was updated
  updatedAt: SB.int(),
  // How many points were added to the score since the last time the user saw the event
  lastScoreAdded: SB.int().optional(),
  // Timestamp when this player was last nudged by the main player
  lastNudgedAt: SB.int().optional(),
});

export type BuddiesPlayer = SB.ExtractType<typeof buddiesPlayerSchema>;

// Schema for an event in the events list
const buddiesEventSchema = SB.object({
  // List of friends that are participating in the event
  party: SB.map(buddiesPlayerSchema),
  // List of invites sent or received by the user
  invites: SB.map(buddiesPlayerSchema),
  // Score of the user
  score: SB.int(),
  // How many points were added to the score since the last time the user saw the event
  lastScoreAdded: SB.int().optional(),
  // Timestamp when the event was seen
  seenAt: SB.int(),
  // Number of nudges sent by the main player this event
  nudgesSentCount: SB.int(),
  // Whether end-of-event rewards have been claimed
  rewardsClaimed: SB.boolean(),
  // Timestamp when FTUE was shown for this event
  ftueSeenAt: SB.int().optional(),
  // Number of entries in `party` (friends only, excluding the owner) that the owner
  // last acknowledged for party-join powerup rewards
  lastSeenPartySize: SB.int().optional(),
});

export type BuddiesEvent = SB.ExtractType<typeof buddiesEventSchema>;

// Schema for the buddies state, containing a list of events
export const buddiesState = SB.object({
  // List of events that user has participated in
  events: SB.map(buddiesEventSchema),
  // Map of rejected suggestion player IDs to rejection timestamp.
  // Optional because existing users won't have this field until they interact with suggestions.
  rejectedSuggestions: SB.map(SB.int()).optional(),
  // When the intro popup was first shown. Event records expire, this does not.
  introducedAt: SB.int().optional(),
});

export type BuddiesState = SB.ExtractType<typeof buddiesState>;

// Schema to be added to the main state
// Note: Using 'bakingBuddies' instead of 'buddies' to avoid conflict with migration 14
// which deletes the old 'buddies' state field
export const buddiesSchema = {
  bakingBuddies: buddiesState.optional(),
};
